  document.querySelectorAll(".vue-fetch-expertise").forEach((el) => {
    new Vue({
        delimiters: ["[[", "]]"],
        el,
        propsData: { ...el.dataset },
        props: {
          expertiseid: {
            type: String,
            default: ""
          },
          urlapi: {
            type: String,
            default: ""
          },
          lang: {
            type: String,
            default: ""
          },
          externaldata: {
            type: String,
            default: ""
          }
        },
        data() {
          return {
            //tab component
            tabIndex: 0,
            tabIndexJob:0,
            totalItems: 0,
            nb_pages: 0,
            items: [],
            loading: true,
            params: {},
            jobTitles: null,
            filters: {
              lang: this.lang
            },
          };
        },
        watch: {

            tabIndex() {
                this.$nextTick(() => {
                    this.adjustContainerHeight();
                    this.getJobTitles()
                  });
            }
        },
        mounted() {            
            this.adjustContainerHeight();
            this.getItems();
            this.getJobTitles();
        },
        computed:{
          getClassSharer() {
            return ind => {
              if(ind == this.activeIndexSharer){
                return 'open-share tw-open-share';
              }
              return false
            }
          }
        },
        methods: {
            adjustContainerHeight() {
                const activeTabContent = this.$refs.activeTabContent;
                if (activeTabContent) {
                  const container = activeTabContent.parentElement;
                  container.style.height = activeTabContent.clientHeight + 'px';
                  container.style.minHeight = activeTabContent.clientHeight + 'px';
                }
            },
            setIndexJob(index) {
                this.tabIndexJob = index;
            },
            setIndex(index) {
                this.tabIndex = index;
            },
            getItemsRecursive(url) {
              axios.get(url)
                  .then(({data}) => {
                      this.items = this.items.concat(data.results);
                      if (data.next) {
                          this.getItemsRecursive(data.next);
                      } else {
                          this.loading = false;
                      }
                  })
                  .catch(error => {
                      console.error("Error during data fetch:", error);
                      this.loading = false;
                  });
            },            
            getItems(search = false) {
                if(search) {
                this.filters.page = 1
                }
                axios.get( "/api/v1/" + this.urlapi, {
                params: {...this.filters, ...this.params}
                })
                .then(({data}) => {
                  this.items = data.results;
                  this.nb_pages = Math.ceil(data.count / this.filters.page_size);
                  this.totalItems = data.count;
                  if (data.next) {
                      this.getItemsRecursive(data.next);
                  } else {
                      this.loading = false;
                  }
              })
            },
            getJobTitles() {
              this.deleteFilter('jobs', 0)
              this.tabIndexJob = 0
              const paramsJobs= {
                expertise: this.expertiseid,
                intervention: this.params.interventions__id ?? null
              }
              axios.get(`/api/v1/lawyer-titles`, {
                params: paramsJobs
              })
              .then(({data}) => {
                this.jobTitles = data.results;
              })
            },
            updateFilter(filter, value, item = null) {
                Vue.set(this.params, filter, value);
                this.getItems()
            },
            deleteFilter(filter) {
                if(filter) {
                  Vue.delete(this.params, filter);
                  this.getItems()
                } else {
                  this.params = {}
                  this.getItems()
                }
            }
        }
      });
  });